import {getArchivedTooltipMessage} from 'analysis-tool/AnalysisToolMessages';
import isArchived from 'archive/isArchived';
import BenchlingConfig from 'BenchlingConfig';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

import {AnalysisTemplateGraphQL} from './templates/AnalysisTemplateTypes';

export type CanEditReturnValue = {canEdit: true; message: null} | {canEdit: false; message: string};

export function checkIsAnalysisArchived(
  analysis: Pick<PipelineGraphQL, 'id' | 'name'>,
  message?: string
): CanEditReturnValue | null {
  if (isArchived(analysis)) {
    return {
      canEdit: false,
      message: message ?? getArchivedTooltipMessage(analysis),
    };
  }
  return null;
}

/**
 * Check if a flowchart should show its edit functionality. Should only be used to determine
 * if we should show the controls on the flowchart, not whether the analysis itself is editable.
 *
 * @param analysis The analysis
 * @returns {shouldShow} False if neither `ENABLE_INSIGHTS_LABS` nor `PIPELINES_ENABLE_CUSTOM_CODE` is enabled
 * or if the analysis is read-only, since we do not show options for editing in that case.
 * Otherwise (including if the analysis is archived or published where we'll show disabled options
 * with explanation), true.
 */
export function showFlowchartEditFunctionality(
  analysis: Pick<PipelineGraphQL, 'permissions'> | Pick<AnalysisTemplateGraphQL, 'permissions'>
): boolean {
  const {writable, archivable, unarchivable} = analysis.permissions;

  return (
    (BenchlingConfig.ENABLE_INSIGHTS_LABS || BenchlingConfig.PIPELINES_ENABLE_CUSTOM_CODE) &&
    (writable || Boolean(archivable) || Boolean(unarchivable))
  );
}
